import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const originalAuthorHandleResolver: FieldResolver = (metadata: Metadata) =>
  ({ originalAuthorHandle: metadata.getOriginalAuthorHandle() } as StreamData)

export default originalAuthorHandleResolver
